import { contactData } from '@/mocks/chiguaHomeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            {contactData.subtitle}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10">
            <div className="flex flex-col md:flex-row gap-8">
              <div className="flex-1">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
                  {contactData.title}
                </h3>

                <div className="space-y-3 mb-6">
                  {contactData.tips.map((tip, i) => (
                    <div key={i} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 shrink-0"></i>
                      <span>{tip}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex-1 flex flex-col justify-center gap-4 p-5 bg-background-50 rounded-xl">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">爆料邮箱</div>
                    <div className="text-sm font-medium text-foreground-900">{contactData.email}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 shrink-0">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">微信投稿</div>
                    <div className="text-sm font-medium text-foreground-900">{contactData.wechat}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}